import { useRef } from 'react';
import { Button, FormHelperText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import 'styles/components/ImageInput.scss';

interface FileInputProps {
  label: string;
  name: string;
  value: File | null;
  setFieldValue: (field: string, value: File | null) => void;
  isSubmitting: boolean;
  onChange?: () => void;
  touched?: boolean;
  errors?: string;
  preview?: string;
  variant?: 'outlined' | 'text' | 'contained';
  color?: 'secondary' | 'primary' | 'inherit';
  quitFileColor?: 'secondary' | 'primary' | 'inherit';
}

function FileInput({
  label,
  name,
  value,
  setFieldValue,
  isSubmitting,
  touched,
  errors,
  variant,
  color,
  onChange,
  quitFileColor,
}: FileInputProps): JSX.Element {
  const { t } = useTranslation();
  const ref = useRef<HTMLInputElement>(null);

  return (
    <>
      {value && (
        <div className="file-name-display">
          <p>{value.name}</p>
        </div>
      )}

      <Button
        fullWidth
        variant={variant || 'contained'}
        color={color || 'primary'}
        component="label"
        disabled={isSubmitting}
      >
        {label}
        <input
          id={name}
          name={name}
          ref={ref}
          type="file"
          hidden
          onChange={(event) => {
            const files = event?.currentTarget?.files;
            if (files && files[0]) {
              if (onChange) onChange();
              setFieldValue(name, files[0]);
            }
          }}
        />
      </Button>

      {value && (
        <div className="delete-file-btn-container">
          <Button
            variant="outlined"
            color={quitFileColor || 'primary'}
            fullWidth
            disabled={isSubmitting}
            onClick={async () => {
              if (ref.current) ref.current.value = '';
              if (onChange) onChange();
              setFieldValue(name, null);
            }}
          >
            {t('remove-file')}
          </Button>
        </div>
      )}

      {touched && value && (
        <FormHelperText variant="outlined" error={true}>
          {errors}
        </FormHelperText>
      )}
    </>
  );
}

export default FileInput;
